import React, { useState, useEffect } from 'react';
import { Table } from 'antd';
import Loader from '../../../utils/Loader';

const SummaryHeaderTable = ({ summaryReport, loading }) => {
  const [rowsData, setRowsData] = useState({ columns: [], rows: [] });

  // console.log('summaryReport', summaryReport);
  useEffect(() => {
    if (summaryReport) {
      let data = { ...rowsData };

      const column = summaryReport.columns
        ? summaryReport.columns.map((each) => {
            return {
              title: each.label,
              dataIndex: each.field,
              key: each.field,
              label: each.label,
              showOnResponse: true,
              showOnDesktop: true,
            };
          })
        : [];
      data.columns = column;
      data.rows = summaryReport.rows || [];
      setRowsData(data);
    }
  }, [summaryReport]);

  // console.log('rowsData', rowsData);
  return (
    <div
      className={`${
        summaryReport && summaryReport.colCount ? summaryReport.colCount : ''
      } mb-2`}
    >
      {loading && <Loader />}
      <Table
        columns={rowsData ? rowsData.columns : []}
        dataSource={
          rowsData
            ? rowsData.rows.map((el, idx) => ({
                key: idx,
                ...el,
              }))
            : []
        }
        bordered
        pagination={rowsData && rowsData.rows.length > 10 ? true : false}
        mobileBreakPoint={768}
      />
    </div>
  );
};

export default SummaryHeaderTable;
